<template>
  <Dialog :title="'Nota'" v-model="show">
    <!-- Contenido del Dialog, Formulario -->
    <template v-slot:content>
      <ValidationObserver  ref="validationObserver">
        <v-form ref="form" class="pa-1" v-if="nota">
          <!-- Empleados -->
          <v-row class="ma-0">
            <v-col cols="12" class="pa-0">
              <ValidationProvider rules="required"
                                  :name="$t('Empleados').toLowerCase()"
                                  v-slot="{ errors, classes }"
              >
                <div class="control" :class="classes">
                    <CustomSelect
                      :label="$t('Empleados')"
                      v-model="nota.empleados"
                      :items="data_form.empleados"
                      :no-data-text="$t('No hay datos')"
                      :select_all="true"
                  />
                </div>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
          </v-row>

          <!-- Título de la nota -->
          <v-row class="ma-0 mt-4">
            <v-col cols="12" class="pa-0">
              <ValidationProvider rules="required"
                                  :name="$t('Título').toLowerCase()"
                                  v-slot="{ errors, classes }"
              >
                <div class="control" :class="classes">
                    <v-text-field
                        hide-details
                      v-model="nota.titulo"
                      :label="$t('Título')"
                      class="mb-1"
                      outlined dense>
                  </v-text-field>
                </div>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
          </v-row>

          <!-- observaciones -->
          <v-row class="ma-0 mt-4">
            <v-col cols="12" class="pa-0">
              <v-textarea
                  auto-grow
                  clearable
                  clear-icon="mdi-close-circle"
                  :label="$t('Observaciones')"
                  rows="10"
                  v-model="nota.observaciones"
                  outlined
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </ValidationObserver>
    </template>
    <!-- Acciones de la derecha del dialog -->
    <template v-slot:right-action>
      <v-btn @click="save" small class="primary">
        <v-icon small>mdi-content-save</v-icon>
        {{  $t("Guardar") }}
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: "FormNota",

  // Obtenemos la propiedad que gestionará el dialog desde fuera y la categoria
  props: ['value', 'item', 'titulo'],

  data: () => ({
    nota: null,
    data_form: {}
  }),

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    /**
     * Obtiene los datos para el formulario
     */
    async get_nota_form() {
      try{
        this.data_form = await this.$store.dispatch('nota/get_form')
      }catch (err) {}
    },

    /**
     * Guarda el formulario y devuelve al componente padre la categoria
     */
    async save() {
      const form_valid = await this.$refs.validationObserver.validate()
      if(form_valid) {
        // Guardamos la nota
        try {
          const nota = await this.$store.dispatch('nota/save', this.nota)
	        this.$snotify.success(
		        this.$t("Acción realizada con éxito"),
		        this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	        )
          this.$emit('on_save', nota)
        } catch (err) {
	        this.$snotify.error(
		        this.$t("Ha ocurrido un error"),
		        this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	        )
        }
      }
    },
  },

  mounted() {
    this.nota = { ... this.item }
    this.get_nota_form()
  },

  components: {
    ValidationProvider, ValidationObserver
  }
}
</script>